import {Loading} from '@hm/fundamental'
import React from 'react'
import {Outlet, Navigate} from 'react-router'

import {useFeatureName} from '../features/useFeatureName'
import {ROUTES} from '../routing/routes'
import {useFeaturesMenu} from '../welcomeFlow/useFeaturesMenu'

import {findFeatureByName} from './findFeatureByName'

export const FeatureNameGuard: React.FC = () => {
  const {featuresMenu} = useFeaturesMenu()
  const featureName = useFeatureName()

  if (!featuresMenu) {
    return (
      <div className="h-screen flex items-center justify-center">
        <Loading size="xlarge" data-cy="menus_loader" />
      </div>
    )
  }

  const validateFeatureByName = (featureName: string) => {
    const featureEntry = findFeatureByName(featuresMenu, featureName)
    if (featureEntry) {
      return true
    }
    return false
  }

  if (validateFeatureByName(featureName)) {
    return <Outlet />
  }

  return <Navigate to={ROUTES.NOT_FOUND.path} />
}
